import { catchNoErr } from '@/utils/catch-error';
import { axiosGet, axiosPost, axiosPut, axiosDelete } from './request';

/* eslint-disable */
export function get(...args: any) {
  // @ts-ignore
  return catchNoErr(axiosGet(...args));
}

/* eslint-disable */
export function post(...args: any) {
  // @ts-ignore
  return catchNoErr(axiosPost(...args));
}

/* eslint-disable */
export function put(...args: any) {
  // @ts-ignore
  return catchNoErr(axiosPut(...args));
}

/* eslint-disable */
export function del(...args: any) {
  // @ts-ignore
  return catchNoErr(axiosDelete(...args));
}

